module.exports = __webpack_public_path__ + "img/CompScope_Space_03.624763b2.png";